import { inject, Injectable } from "@angular/core";
import { MCAuthoritiesEventsGeneric, MCAuthoritiesEventsModelCode, MCCustomFunctionsParams, MCModelCode } from "@maslul/common-services";
import { Observable, of } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class AuthoritiesEventsModelCode extends MCAuthoritiesEventsModelCode {

    private authoritiesEventsGeneric = inject(MCAuthoritiesEventsGeneric);

    override getModelCodeObservable(customFunctionsParams: MCCustomFunctionsParams): Observable<Array<any>> {
        this.authoritiesEventsGeneric.noImplementFunction(customFunctionsParams, 'getModelCodeObservable');
        return of([]);
    }
    override getModelCodeList(customFunctionsParams: MCCustomFunctionsParams): void {
        this.authoritiesEventsGeneric.noImplementFunction(customFunctionsParams, 'getModelCodeList');
    }
    override newValueAddedToModelCodeList(customFunctionsParams: MCCustomFunctionsParams): void {
        this.authoritiesEventsGeneric.noImplementFunction(customFunctionsParams, 'newValueAddedToModelCodeList');
    }
    override setModelCodeChanged(customFunctionsParams: MCCustomFunctionsParams): void {
        this.authoritiesEventsGeneric.noImplementFunction(customFunctionsParams, 'setModelCodeChanged');
    }
    override setModelDescriptionChanged(customFunctionsParams: MCCustomFunctionsParams): void {
        this.authoritiesEventsGeneric.noImplementFunction(customFunctionsParams, 'setModelDescriptionChanged');
    }
    override getModelCodeModel(customFunctionsObj: MCCustomFunctionsParams): MCModelCode {
        this.authoritiesEventsGeneric.noImplementFunction(customFunctionsObj, 'getModelCodeModel');
        return {} as MCModelCode;
    }
}
